import React, {ReactElement} from 'react';

import {CheckedIcon} from '../../../Icons';

interface Props {
  text: string;
}

function FormLayoutSidebarAdvantage({text}: Props): ReactElement {
  return (
    <li>
      <CheckedIcon />
      {text}
    </li>
  );
}

export default FormLayoutSidebarAdvantage;
